import styled, { css } from 'styled-components';
import { HEADER_HEIGHT } from './constants';
import { device } from 'constants/index';
import startScreen from 'assets/img/startScreen.png';
import smallWelcomeScreen from 'assets/img/smallWelcomeScreen.png';

const Layout = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    prop !== 'isLeftLogoHidden' && prop !== 'isLogoAnimated',
})<{ isLeftLogoHidden: boolean; isLogoAnimated: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #fff;
  position: relative;

  @media ${device.md} {
    overflow-y: auto;
  }

  & .layoutHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 100px 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    @media ${device.lg} {
      padding: 60px 30px 0;
    }
    @media ${device.md} {
      padding: 60px 30px 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }

  & .layoutContent {
    display: flex;
    height: 100%;
    max-height: 100%;
    padding-top: ${HEADER_HEIGHT}px;
    overflow-y: auto;
  }

  & .headerIcon {
    opacity: 0;
    animation: fadeIn 0.2s 0s ease-in forwards;
  }

  ${({ isLeftLogoHidden }) =>
    isLeftLogoHidden &&
    css`
      background-image: linear-gradient(90deg, #F1F1F1 59%, transparent 65%), url(${startScreen});
      background-repeat: no-repeat;
      background-position-x: right;
      background-size: contain;

      opacity: 0;
      animation: fadeIn 0.1s 1s ease-in forwards;

      & .headerIcon {
        visibility: hidden;
      }

      @media ${device.md} {
        background-image: linear-gradient(0deg, #F1F1F1 35%, transparent 65%), url(${smallWelcomeScreen});
        width: 100%;
        overflow-y: auto;
        & .layoutHeader {
          padding: 60px 30px 0;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
        }
      }

      @media ${device.sm} {
        background-image: linear-gradient(0deg, #F1F1F1 55%, transparent 65%), url(${smallWelcomeScreen});
      } 
    `}



  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  
`;

export { 
  Layout
};
